import { render } from "./TuoPublish.vue?vue&type=template&id=6fa93b76"
import script from "./TuoPublish.vue?vue&type=script&lang=js"
export * from "./TuoPublish.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__